import { Translate } from '@travel/translation';

import { InstallmentsTimesEnum, PaymentType } from 'constants/reservations';
import { InstallmentLabels, paymentTypeLabels } from 'constants/reservations';
import type { CardInstallments } from 'ReservationsList-Types';

export const getPaymentMethodDisplayText = (
  paymentMethod: PaymentType,
  cardInstallments?: CardInstallments,
) => {
  return paymentMethod === PaymentType.CREDIT_CARD
    ? InstallmentLabels[cardInstallments || InstallmentsTimesEnum.INSTALLMENTS_1]
    : paymentTypeLabels[paymentMethod];
};

// Backward compatibility function
export const getInstallmentShortText = (installments?: CardInstallments) => {
  if (!installments || installments === InstallmentsTimesEnum.INSTALLMENTS_1) {
    return <Translate id="ReservationDetail.PaymentMethod.LumpSum" />;
  }
  return (
    <Translate id="ReservationDetail.PaymentMethod.Installment" data={{ count: installments }} />
  );
};
